import React from 'react';
import NoSSR from 'react-no-ssr';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ad from '@ifeng-fe/ui_pc_ad';
import Search from '@ifeng-fe/ui_pc_search';
import Logo from './logo';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { topAd, search },
        } = this.props;

        return (
            <header>
                <div className={styles.topAd_box}>
                    <NoSSR>
                        <Ad content={topAd} styleName={styles.topAd} />
                    </NoSSR>
                </div>
                <div className={styles.search_bar}>
                    <Logo />
                    <NoSSR>
                        <Chip id="20005" type="struct" title="搜索" groupName="头部" content={search}>
                            <Search />
                        </Chip>
                    </NoSSR>
                </div>
                <div className={styles.devide} />
            </header>
        );
    }
}

export default errorBoundary(Header);
